<div class="container text-center vh-100 container-login-overlay">
	<div
		class="d-flex flex-column align-items-center justify-content-center vh-100"
	>
		<img
			class="img-fluid img-logo bounce-animation"
			src="/assets/images/baseerp.svg"
			alt="BaseERP"
		/>
		<div>
			<div class="progress-bar fade-animation">
				<div class="bar"></div>
			</div>
			<p class="text-primary fade-animation p-4">
				{{ "GLOBAL.MODAL_LOGIN_ASAAS_OVERLAY.TITLE" | translate }}
			</p>
		</div>
	</div>
</div>
